import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const UDCApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "UDC" */ "./UDCApp");
    return { default: namedExport.UDCApp };
});

export const UDC: TeamAppConfig = {
    title: "M365 Unified Privacy Governance Hub",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: " M365 Unified Privacy Governance Hub",
    team: "Data Insight",
    publicId: "SERVICEOPERATIONANDTELEMETRYDATASTANDARDIZATION\\DataInsightPlatform",
    owner: "universedatacatalog@microsoft.com",
    role: "*",
    tags: [],
    app: UDCApp,
    path: "/UDC"
};
